jQuery(document).ready(function ($) {
    const gallery = new Swiper('.gallery', {
        loop: true,

        slidesPerView: 1,

        longSwipes: false,

        crossFade: true,
        effect: 'fade',

        pagination: {
            el: '.gallery__pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: true,
        delay: 8000,
        speed: 500,
    });
});